import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import usePayloadMappingForm from "./usePayloadMappingForm";
import PayloadMappingForm from "./PayloadMappingForm";

export default PayloadMappingFormDialog;

function PayloadMappingFormDialog(props) {
  const {
    onClose,
    payloadMappingDialog,
    addPayloadMapping,
    updatePayloadMapping,
  } = props;

  const { formState, updateFormState, errors, validate } =
    usePayloadMappingForm(payloadMappingDialog.mapping);

  const isModeAdd = payloadMappingDialog.mode === "add";

  const handlePrimary = () => {
    if (!validate()) {
      return;
    }

    isModeAdd ? addPayloadMapping(formState) : updatePayloadMapping(formState, payloadMappingDialog.mappingIdx);
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{isModeAdd ? "Add Mapping" : "Edit Mapping"}</DialogTitle>
      <DialogBody>
        <PayloadMappingForm
          formState={formState}
          errors={errors}
          updateFormState={updateFormState}
        />
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onClose}>Cancel</Button>
        <Button onClick={handlePrimary}>{isModeAdd ? "Add" : "Save"}</Button>
      </DialogActions>
    </Dialog>
  );
}
